<template>
  <div class="animated fadeIn" v-if="!pageLoading">
    <loading v-if="vLoading" />
    <v-col lg="12" class="ml-auto"></v-col>
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>S</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ذخیره پیش‌نویس <br /><br />
          <v-btn elevation="6" outlined small>P</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          نسخه چاپی استعلام <br /><br />
          <v-btn elevation="6" outlined small>q</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          بروزرسانی موجودی <br /><br />
          <v-btn elevation="6" outlined small>Shift</v-btn> ورود به حالت تعیین
          قیمت و بالعکس <br /><br />
          <v-btn elevation="6" outlined small>+</v-btn> افزودن محصول جدید
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <div v-if="role == 'Manager' || role == 'salesManager'" active>
      <b-card>
        <template v-slot:header>
          <v-row :class="customer.customer_priority">
            <v-col cols="7" class="mt-4">
              <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

              <h5>نام مشتری: {{ orderInfo.customerName }}</h5>
              <h5>رتبه مشتری: {{ orderInfo.customer_priority }}</h5>
              <h5>شماره درخواست مشتری: {{ orderInfo.originalRequestId }}</h5>
              <h5>
                نوع استعلام:
                {{
                  orderTypes.filter((x) => x.value == orderInfo.orderType)[0]
                    .text
                }}
              </h5>
            </v-col>
            <v-col cols="5" class="mt-4">
              <v-col>
                <v-row>
                  <v-col>
                    <h4>وضعیت پرونده: {{ orderInfo.status }}</h4>
                    <h5>تاریخ ثبت استعلام: {{ orderInfo.registerDate }}</h5>
                    <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                    <h5>
                      کارشناس بازرگانی:
                      {{ orderInfo.assigneeName }}
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </template>

        <b-card
          class="shadow mb-5 bg-white rounded"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template v-slot:header>
            <v-row>
              <v-col cols="4">
                <h6 style="display: inline">صدور استعلام</h6>
              </v-col>
              <!-- <v-col cols="2">
                  <b-form-select
                    :options="currencyOptions"
                    v-model="currency"
                  />
                </v-col> -->
            </v-row>
          </template>

          <v-row class="mb-3 item-ckeditor">
            <v-col cols="10">
              <ckeditor
                v-if="!showCustomerTerms"
                v-model="orderInfo.customerTerms"
                :editor="editor"
                :config="editorConfig"
              ></ckeditor>
              <div
                v-if="showCustomerTerms"
                v-html="orderInfo.customerTerms"
                style="border: 1px solid black"
                class="p-1 rounded"
              />
            </v-col>
            <v-col cols="2">
              <b-btn
                variant="warning"
                class="mr-1"
                style="float: left"
                @click="toggleCustomerTerms()"
                >{{
                  showCustomerTerms ? "ویرایش متن بالا" : "ثبت تغییرات"
                }}</b-btn
              >
            </v-col>
          </v-row>

          <b-table
            small
            responsive
            show-empty
            :items="filtered"
            :fields="fieldsCI"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template slot="top-row">
              <td v-for="field in fieldsCI" :key="field.key">
                <b-form-input
                  v-if="
                    field.label != '#' &&
                    field.key != 'operation' &&
                    field.key != 'selected'
                  "
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                ></b-form-input>

                <b-btn
                  v-else-if="field.key == 'selected'"
                  variant="dark"
                  class="m-1"
                  @click="toggleSelectAll()"
                  >همه/هیچ</b-btn
                >

                <p v-else-if="field.label == '#'">
                  <!-- <b-btn
                      :disabled="selectedItems.reduce((a, b) => a + b) < 2"
                      variant="dark"
                      class="mr-2"
                      @click="editSelected()"
                      ><i class="fa fa-edit"> </i
                    ></b-btn> -->
                </p>
              </td>
            </template>
            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.index + 1 }}
                <br />
                <!-- <b-form-checkbox
                    v-model="selectedItems[data.index]"
                  ></b-form-checkbox> -->
              </div>
            </template>
            <template v-slot:cell(selected)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-checkbox
                  :disabled="onlyChangePrice"
                  v-model="data.item.selected"
                  @change="syncUpdateTable()"
                ></b-form-checkbox>
              </div>
            </template>
            <template v-slot:cell(customerIndex)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-input
                  :disabled="onlyChangePrice"
                  v-model="data.item.customerIndex"
                  type="text"
                ></b-form-input>
              </div>
            </template>

            <template v-slot:cell(totalPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                {{ (data.item.perPrice * data.item.number).toLocaleString() }}
              </div>
            </template>

            <template v-slot:cell(perPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <vuetify-money
                  v-model="data.item.perPrice"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                  outlined
                  dense
                />
                <br />
                <!-- <span>{{ sarmadNumber2(data.item.perPrice) }}</span> -->
              </div>
            </template>
          </b-table>
          <v-row class="mb-3">
            <v-col cols="5"
              >قیمت اقلام:
              {{
                orderInfo.orderItems.length > 0
                  ? sarmadNumber2(
                      orderInfo.orderItems
                        .map(
                          (x) =>
                            (x.perPrice
                              ? String(x.perPrice).replace(/\s/g, "")
                              : 0) *
                            (x.number ? String(x.number).replace(/\s/g, "") : 0)
                        )
                        .reduce((a, b) => a + b)
                    )
                  : "--"
              }}
              {{ orderInfo.currency }}
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2">واحد پول:</v-col>
            <v-col cols="3">
              <b-form-select
                :options="currencyOptions"
                v-model="orderInfo.currency"
              />
            </v-col>
          </v-row>
          <v-row class="mb-3">
            <v-col cols="2">درصد تغییر قیمت:‌</v-col>
            <v-col cols="2">
              <v-text-field
                v-model="multiplier"
                type="number"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <b-btn variant="warning" @click="multiply()">اعمال</b-btn>
            </v-col>
            <v-col cols="6">
              <b-form-select
                :options="measurementUnits"
                v-model="measurementUnit"
              />
            </v-col>
          </v-row>

          <table border="1px solid" width="100%" style="text-align: center">
            <tr>
              <th class="py-2">قیمت اقلام</th>
              <th>
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map((x) =>
                            parseInt(
                              x.number ? String(x.number).replace(/\s/g, "") : 0
                            )
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                قلم
              </th>
              <th>
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map(
                            (x) =>
                              (x.perPrice
                                ? String(x.perPrice).replace(/\s/g, "")
                                : 0) *
                              (x.number
                                ? String(x.number).replace(/\s/g, "")
                                : 0)
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                {{ currency }}
              </th>
            </tr>
            <tr>
              <td>هزینه بسته‌بندی</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.packagingCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.packagingCost).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>هزینه حمل</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.transportCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.transportCost).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>هزینه بازرسی شخص ثالث</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.personCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.personCost).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>هزینه پوشش دهی (%)</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.coatingCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="options"
                  type="number"
                />
              </td>
              <td>
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map(
                            (x) =>
                              (x.perPrice
                                ? x.perPrice.toString().replace(/\s/g, "")
                                : 0) *
                              (x.number
                                ? x.number.toString().replace(/\s/g, "")
                                : 0)
                          )
                          .reduce((a, b) => a + b) *
                          (orderInfo.coatingCost / 100)
                      )
                    : "--"
                }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>هزینه تست و صدور گواهینامه</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.certificationCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.certificationCost).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>سایر هزینه‌ها</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.otherCost"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.otherCost).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr>
              <td>تخفیف {{ orderInfo.currency }}ی</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.discount"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                />
              </td>
              <td>
                {{ parseFloat(orderInfo.discount).toLocaleString() }}
                {{ orderInfo.currency }}
              </td>
            </tr>
            <tr
              v-if="
                orderInfo.discount +
                orderInfo.packagingCost +
                orderInfo.transportCost +
                orderInfo.personCost +
                orderInfo.certificationCost +
                orderInfo.otherCost
              "
            >
              <th class="py-2">قیمت کل بدون مالیات</th>
              <th>
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map((x) =>
                            parseInt(
                              x.number ? String(x.number).replace(/\s/g, "") : 0
                            )
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                قلم
              </th>
              <th>
                {{
                  totalPriceVatExcluded(
                    orderInfo.orderItems,
                    orderInfo.discount,
                    orderInfo.packagingCost,
                    orderInfo.transportCost,
                    orderInfo.personCost,
                    orderInfo.certificationCost,
                    orderInfo.otherCost,
                    orderInfo.currency
                  )
                }}
              </th>
            </tr>
            <tr>
              <td>مالیات بر ارزش افزوده (%)</td>
              <td class="px-5">
                <vuetify-money
                  v-model="orderInfo.orderVat"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="options"
                  type="number"
                />
              </td>
              <td>
                {{
                  totalVat(
                    orderInfo.orderItems,
                    orderInfo.discount,
                    orderInfo.packagingCost,
                    orderInfo.transportCost,
                    orderInfo.personCost,
                    orderInfo.certificationCost,
                    orderInfo.otherCost,
                    orderInfo.currency,
                    orderInfo.orderVat
                  )
                }}
              </td>
            </tr>
            <tr>
              <th class="py-2">قیمت کل</th>
              <th>
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map((x) =>
                            parseInt(
                              x.number ? String(x.number).replace(/\s/g, "") : 0
                            )
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                قلم
              </th>
              <th>
                {{
                  totalPrice(
                    orderInfo.orderItems,
                    orderInfo.discount,
                    orderInfo.packagingCost,
                    orderInfo.transportCost,
                    orderInfo.personCost,
                    orderInfo.certificationCost,
                    orderInfo.otherCost,
                    orderInfo.currency,
                    orderInfo.orderVat
                  )
                }}
              </th>
            </tr>
            <tr v-if="orderInfo.price">
              <th class="py-2"><em>آخرین قیمت اعلامی به مشتری</em></th>
              <td></td>
              <td>
                <em>
                  {{ orderInfo.price.toLocaleString() }}
                  {{ orderInfo.currency }}
                </em>
              </td>
            </tr>
          </table>

          <hr />
          <v-row class="item-ckeditor">
            <v-col cols="10">
              <ckeditor
                v-if="!showPurchaseTemrs"
                v-model="orderInfo.terms"
                :editor="editor"
                :config="editorConfig"
              ></ckeditor>
              <div
                v-if="showPurchaseTemrs"
                v-html="orderInfo.terms"
                style="border: 1px solid black"
                class="p-2 rounded"
              />
            </v-col>
            <v-col cols="2">
              <b-btn
                variant="warning"
                class="mr-1"
                style="float: left"
                @click="togglePurchaseTerms()"
                >{{
                  showPurchaseTemrs ? "ویرایش متن پایین" : "ثبت تغییرات"
                }}</b-btn
              >
            </v-col>
          </v-row>
          <hr />
          <a
            class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
            style="float: right"
            :href="'/' + role + '/order/' + $route.params.id"
            target="_blank"
          >
            مشاهده پرونده سفارش
          </a>

          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="editOrder()"
            >اعمال تغییرات</b-btn
          >
          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="submitQuote()"
            v-if="orderInfo.status == 'ثبت استعلام'"
            :disabled="
              !(role == 'trade' || role == 'tradeHead' || role == 'Manager')
            "
            >ارسال به کارشناس فنی</b-btn
          >
          <b-btn
            variant="danger"
            class="mr-1"
            style="float: left"
            v-if="
              orderInfo.status == 'در انتظار بررسی فنی' ||
              orderInfo.status == 'تعیین قیمت توسط مدیر عامل'
            "
            :disabled="
              !(
                role == 'tradeHead' ||
                role == 'Manager' ||
                role == 'salesManager'
              )
            "
            @click="sendBacktoTrade()"
            >برگشت به کارشناس بازرگانی</b-btn
          >
          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="sendToCeoPricing()"
            v-if="orderInfo.status == 'در انتظار بررسی فنی'"
            :disabled="
              !(
                role == 'tradeHead' ||
                role == 'Manager' ||
                role == 'salesManager'
              )
            "
          >
            {{
              orderInfo.orderType == "full"
                ? "ارسال به مدیر عامل جهت تعیین قیمت"
                : "ارسال به مدیر عامل جهت امضا"
            }}
          </b-btn>

          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="submitQuotePrice()"
            v-if="orderInfo.status == 'تعیین قیمت توسط مدیر عامل'"
            :disabled="!(role == 'ceo' || role == 'Manager')"
            >ثبت اولیه تعیین قیمت</b-btn
          >

          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="sendToCeoSign()"
            v-if="orderInfo.status == 'بررسی تعیین قیمت توسط مدیر فروش'"
            :disabled="!(role == 'salesManager' || role == 'Manager')"
            >تایید تعیین قیمت - ارسال جهت امضا</b-btn
          >

          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="signQuote()"
            v-if="orderInfo.status == 'آماده برای امضا'"
            :disabled="!(role == 'ceo' || role == 'Manager')"
            >امضا</b-btn
          >
        </b-card>

        <br />
      </b-card>
      <!--dialog  -->
      <v-dialog v-model="deleteDialog" max-width="500px" header-color="error">
        <v-card>
          <v-card-title>
            <h4>حذف کل موارد جدول</h4>
          </v-card-title>
          <v-card-text class="pb-0 pt-3 px-3">
            <v-container>
              <p>آیا از حذف کلیه محصولات وارد شده مطمئن هستید؟</p>
              <p style="font-weight: bold; color: red">
                این کار غیر قابل برگشت است!
              </p>
            </v-container>
          </v-card-text>
          <v-card-actions class="p-3 mr-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="deleteDialog = false"> لغو </v-btn>
            <v-btn class="text-white" color="red" @click="doDelAll()">
              حذف کن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="editSelectedModal"
        max-width="500px"
        header-color="error"
      >
        <v-card>
          <v-card-title>
            <h4>ویرایش گروهی</h4>
          </v-card-title>
          <v-card-text class="pb-0 pt-3 px-3">
            <v-container>
              <p dir="ltr">
                {{
                  orderInfo.orderItems.filter(
                    (item, index) => selectedItems[index]
                  )
                }}
              </p>
            </v-container>
          </v-card-text>
          <v-card-actions class="p-3 mr-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="editSelectedModal = false">
              لغو
            </v-btn>
            <v-btn class="text-white" color="red" @click="doEditSelected()">
              حذف کن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import prices from "../../mixins/prices";

export default {
  mixins: [prices],
  components: {
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: "fa",
        contentsLangDirection: "rtl",
      },
      guide: false,
      selectedItems: [],
      editSelectedModal: false,
      bulkEditFrom: "",
      bulkEditTo: "",
      valueWhenIsEmpty: "0",
      options: {
        decimal: ".",
        thousands: ",",
        precision: 0,
        min: 0,
      },
      role: "",
      followContent: "",
      getContent: "",
      sendBackReason: "",
      rejectReason: "",
      items: [],
      filter: null,
      isBusy: false,
      isBusy2: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      batchText: "",
      batchData: [],
      itemsHistory: [],
      multiplier: 0,
      multiplierCount: 0,
      fields: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      warehouseItems: [],
      warehouseFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      warehouseSingleFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      filtersWarehouse: [],
      currentWarehousePage: 1,
      perPageWarehouse: 25,
      totalRowsWarehouse: 0,
      isBusyWarehouse: false,
      isBusySingleWarehouse: false,
      analyzeOneItemModal: false,
      selectedItem: {},
      fieldsHistory2: [
        { key: "index", label: "#" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "currency", label: "واحد پول" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "operation", label: "پرونده استعلام" },
      ],
      formTemplates: [
        { value: "pk1", text: "الگوی PK1 فارسی" },
        { value: "pk2", text: "الگوی PK2 فارسی" },
        { value: "pken", text: "الگوی PK1 انگلیسی" },
        { value: "pken2", text: "الگوی PK2 انگلیسی" },
      ],
      measurementUnit: "",
      measurementUnits: [
        { value: "تعداد", text: "تعداد" },
        { value: "کیلوگرم", text: "کیلوگرم" },
        { value: "تن", text: "تن" },
      ],
      formTemplate: "",
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      currency: "",
      hasCustomerIndex: false,
      hasSizeStandard: true,
      allOrders: [],
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
          ],
        ],
        height: 200,
      },
      purchaseTerms: "",
      striped: true,
      showBatchArea: false,
      showBatchTable: false,
      showPurchaseTemrs: true,
      showCustomerTerms: true,
      customerInfo: {},
      orderInfo: {},
      onlyChangePrice: false,
      filterFile: "",
      isBusyFile: false,
      itemsFile: [],
      fieldsFile: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ آپلود" },
        { key: "name", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      journals: [],
      filters: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      filtersHistory: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      deleteDialog: false,
      sendMethods: [
        "پاکت دربسته",
        "ایمیل",
        "فاکس",
        "واتساپ",
        "سایر روش‌ها (در توضیحات ذکر شود)",
      ],
      sendMethod: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      customerHistory: [],
      orderVat: 0,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      otherCost: 0,
      certificationCost: 0,
      discount: 0,
      customerOrders: [],
      ordersTotalRows: 0,
      staticOrdersTotalRows: 0,
      agents: [],
      agentsTotalRows: 0,
      staticAgentsTotalRows: 0,
      customer: {},
      customerOrdersFields: [
        { key: "index", label: "ردیف" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
      ],
      customerOrdersIsBusy: true,
      customerOrdersFilter: null,
      currentPageOrder: 1,
      agentsFilter: null,
      agentsIsBusy: true,
      currentPageContact: 1,
      agentsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
        // { key: "operation", label: "عملیات" },
      ],
      replaceFields: [
        { key: "details", label: "توضیحات تکمیلی", value: false },
        { key: "number", label: "واحد", value: false },
        { key: "length", label: "طول", value: false },
        { key: "diameter", label: "قطر", value: false },
        { key: "dimensionStandard", label: "استاندارد ابعاد", value: false },
        { key: "cover", label: "پوشش", value: false },
        { key: "material", label: "متریال", value: false },
        { key: "description", label: "شرح کالا", value: false },
      ],
      updateAllItems: [
        {
          details: "",
          number: "",
          length: "",
          diameter: "",
          dimensionStandard: "",
          cover: "",
          material: "",
          description: "",
        },
      ],
      updateTableBusy: false,
      vLoading: false,
      pageLoading: false,
    };
  },

  methods: {
    toggleCustomerTerms() {
      this.showCustomerTerms = !this.showCustomerTerms;
    },
    editOrder() {
      Axios.post(
        this.baseUrl + "/ppkpms/office/order/editOrder",
        {
          orderId: this.$route.params.id,
          note: this.orderInfo.note,
          measurementUnit: this.measurementUnit,
          description: this.orderInfo.description,
          productsTemplate: this.orderInfo.productsTemplate,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.orderInfo.terms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.orderInfo.hasCustomerIndex,
          hasSizeStandard: this.orderInfo.orderHasSizeStandard,
          orderVat: this.orderInfo.orderVat,
          packagingCost: this.orderInfo.packagingCost,
          transportCost: this.orderInfo.transportCost,
          personCost: this.orderInfo.personCost,
          coatingCost: this.orderInfo.coatingCost,
          otherCost: this.orderInfo.otherCost,
          discount: this.orderInfo.discount,
          currency: this.orderInfo.currency,
          certificationCost: this.orderInfo.certificationCost,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getTaskInfo() {
      this.vLoading = true;
      this.pageLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.vLoading = false;
            this.pageLoading = false;
            this.orderInfo = res.data;
            this.measurementUnit = this.orderInfo.measurementUnit || "تعداد";
            this.currency = this.orderInfo.currency || "ریال";
            this.orderInfo.orderItems = JSON.parse(this.orderInfo.orderItems);
            if (!res.data.hasCustomerIndex) {
              this.originalOrderFields = this.originalOrderFields.filter(
                (x) => x.key != "customerIndex"
              );
            }
            // this.factoryInfo = JSON.parse(this.orderInfo.factoryInfo);
            this.orderItems = this.orderInfo.items;
            this.orderItems.forEach((service) => {
              if (service.status == "توقف موقت تولید") {
                service._rowVariant = "danger";
              }
            });
            // this.orderItems.forEach((item) => {
            //   item.inventory = "?";
            // });
            // this.checkAllInventory();
            this.history = this.orderInfo.factoryHistory;
            this.factoryOrderFiles = this.orderInfo.factoryFiles
              ? JSON.parse(this.orderInfo.factoryFiles)
              : "";
            this.totalRows = this.orderItems.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.vLoading = false;
          this.pageLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    toggleHelp() {
      this.guide = !this.guide;
    },

    goToPrintPreview(type) {
      let routeData = this.$router.resolve({
        path:
          "/" +
          this.role +
          "/printPreview/" +
          type +
          "/" +
          this.$route.params.id,
      });
      window.open(routeData.href, "_blank");
    },

    sarmadNumber2(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";

      try {
        let temp1 = parseFloat(data).toFixed(
          this.currencyOptions.filter(
            (x) => x.value == this.orderInfo.currency
          )[0].precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "--";
      }
    },

    sendToCeoPricing() {
      if (this.orderInfo.orderType == "full") {
        if (
          this.orderInfo.orderItems
            .map(
              (x) =>
                (x.perPrice ? x.perPrice.toString().replace(/\s/g, "") : 0) *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) == 0
        )
          this.getAllPrices();
      }
      Axios.post(
        this.baseUrl + "/ppkpms/order/approveTechnicalQuote",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitQuote() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/submitQuote",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          certificationCost: this.certificationCost || 0,
          coatingCost: this.coatingCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    sendToCeoSign() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/sendToCeoSign",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.orderInfo.customerTerms,
            terms: this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
    signQuote() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/signQuote",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.orderInfo.customerTerms,
            terms: this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },

    sendBacktoTrade() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendBacktoTrade",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    checkSimilarPrices() {
      this.vLoading = true;
      var errors = [];
      var compareFields = this.myFields;
      compareFields = compareFields.filter((x) => x.key != "perPrice");
      compareFields = compareFields.filter((x) => x.key != "totalPrice");
      compareFields = compareFields.filter((x) => x.key != "operation");
      compareFields = compareFields.filter((x) => x.key != "details");
      compareFields = compareFields.filter((x) => x.key != "totalPrice");
      compareFields = compareFields.filter((x) => x.key != "number");
      compareFields = compareFields.filter((x) => x.key != "index");
      compareFields = compareFields.filter((x) => x.key != "customerIndex");
      compareFields = compareFields.filter((x) => x.key != "selected");

      this.orderInfo.orderItems.forEach((item) => {
        item.identifier = "";
        compareFields.forEach((field) => {
          item.identifier += item[field.key]
            ? item[field.key].toLowerCase().split(" ").join("")
            : "";
        });
      });

      var onlyIdentifiers = this.orderInfo.orderItems.map((x) => x.identifier);
      onlyIdentifiers = onlyIdentifiers.map((item, index) => {
        return {
          item: item,
          index: index,
        };
      });
      onlyIdentifiers.forEach((item, index) => {
        var similarItems = onlyIdentifiers.filter((x) => x.item == item.item);
        if (similarItems.length > 1) {
          var basePrice = Number(
            this.orderInfo.orderItems[similarItems[0].index].perPrice
          );
          similarItems.forEach((element) => {
            if (
              basePrice !=
              Number(this.orderInfo.orderItems[element.index].perPrice)
            )
              errors.push({
                firstOrderIndex: similarItems[0].index,
                firstItemPrice:
                  this.orderInfo.orderItems[similarItems[0].index].perPrice,
                secondOrderIndex: element.index,
                secondItemPrice:
                  this.orderInfo.orderItems[element.index].perPrice,
              });
          });
        }
      });

      this.vLoading = false;
      if (errors.length == 0) {
        return "OK";
      } else {
        var errorMessage = "";
        errorMessage +=
          "خطا: سطر " +
          Number(errors[0].firstOrderIndex + 1) +
          " و سطر " +
          Number(errors[0].secondOrderIndex + 1) +
          " دارای ویژگی‌های مشابه ولی قیمت متفاوت هستند";
        return errorMessage;
      }
    },
    submitQuotePrice() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/submitQuotePrice",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.orderInfo.customerTerms,
            terms: this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
    draft() {
      this.toast("در حال ذخیره سازی... لطفا چند لحظه صبر کنید", "warning");
      Axios.post(
        this.baseUrl + "/ppkpms/order/draft",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("پیش‌نویس با موفقیت ذخیره شد", "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    sarmadNumber(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
      try {
        let temp1 = parseFloat(
          parseFloat(data).toFixed(
            this.currencyOptions.filter((x) => x.value == this.currency)[0]
              .precision
          )
        );
        return temp1 ? temp1 : 0;
      } catch (error) {
        return 0;
      }
    },
    addOffer() {
      this.orderInfo.orderItems.push({
        // totalPrice: "",
        perPrice: 0,
        number: 0,
        length: "",
        diameter: "",
        // dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        // details: "",
        // customerIndex: ""
      });
    },

    delBatch(order) {
      this.batchData.splice(order, 1);
    },
    addItem(item) {
      this.orderInfo.orderItems.push({
        totalPrice: item.totalPrice,
        perPrice: item.perPrice,
        number: item.number,
        length: item.length,
        diameter: item.diameter,
        dimensionStandard: item.dimensionStandard,
        cover: item.cover,
        material: item.material,
        description: item.description,
        details: item.details,
        customerIndex: item.customerIndex,
      });
    },

    getAllPrices() {
      this.vLoading = true;
      var counter = 0;
      var totalCount = this.orderInfo.orderItems.length;
      var priceFields = this.myFields;
      var myFilteredHistory = this.filteredHistory;
      priceFields = priceFields.filter((x) => x.key != "perPrice");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "operation");
      priceFields = priceFields.filter((x) => x.key != "details");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "number");
      priceFields = priceFields.filter((x) => x.key != "index");
      priceFields = priceFields.filter((x) => x.key != "customerIndex");
      priceFields = priceFields.map((x) => x.key);

      this.orderInfo.orderItems.forEach((item) => {
        try {
          myFilteredHistory = this.filteredHistory;
          priceFields.forEach((thisField) => {
            try {
              myFilteredHistory = myFilteredHistory.filter(
                (x) =>
                  x[thisField].toLowerCase().split(" ").join("") ==
                  item[thisField].toLowerCase().split(" ").join("")
              );
            } catch (error) {
              console.log(item[thisField]);
            }
          });

          myFilteredHistory = myFilteredHistory.filter((x) => x.perPrice);

          if (myFilteredHistory.length) {
            item.oldPerPrice = item.perPrice;
            item.perPrice = myFilteredHistory[0].perPrice;
            counter++;
            if (counter == totalCount) this.vLoading = false;
          } else {
            counter++;
            if (counter == totalCount) this.vLoading = false;
          }
        } catch (error) {
          counter++;
          if (counter == totalCount) this.vLoading = false;
        }
      });
    },
    batchAdd() {
      this.showBatchArea = !this.showBatchArea;
    },
    analyzeBatch() {
      let batchDataArray = this.batchText.split(",").join("").split("\n");
      if (this.hasSizeStandard) {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                perPrice: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                number: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                length: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                diameter: x.split("\t")[2]
                  ? x.split("\t")[2].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                perPrice: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                number: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                length: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                diameter: x.split("\t")[1]
                  ? x.split("\t")[1].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      } else {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      }

      this.showBatchTable = true;
    },
    delAnalyzeBatch() {
      this.batchData = [];
      this.showBatchTable = false;
    },
    doBatchAdd() {
      this.orderInfo.orderItems = this.orderInfo.orderItems.concat(
        this.batchData
      );
      this.batchText = "";
      this.batchData = [];
      this.showBatchTable = false;
      this.showBatchArea = false;
    },

    togglePurchaseTerms() {
      this.showPurchaseTemrs = !this.showPurchaseTemrs;
    },
    multiply() {
      this.orderInfo.orderItems.forEach((x) => {
        x.perPrice = this.sarmadNumber(
          x.perPrice * (1 + this.multiplier / 100)
        );
      });
      this.multiplier = 0;
    },

    delAll() {
      this.deleteDialog = true;
    },

    doDelAll() {
      this.orderInfo.orderItems = [];
      this.deleteDialog = false;
    },
    editSelected() {
      this.editSelectedModal = true;
    },
    toggleSelectAll() {
      this.vLoading = true;
      this.updateTableBusy = true;
      if (
        this.orderInfo.orderItems.length ==
        this.orderInfo.orderItems.filter((x) => x.selected).length
      )
        this.orderInfo.orderItems.forEach((element) => {
          element.selected = false;
        });
      else
        this.orderInfo.orderItems.forEach((element) => {
          element.selected = true;
        });

      setTimeout(() => {
        this.vLoading = false;
        this.updateTableBusy = false;
      }, 250);
    },
    syncUpdateTable() {
      this.updateTableBusy = true;
      setTimeout(() => {
        this.updateTableBusy = false;
      }, 250);
    },
  },

  computed: {
    myFields() {
      let myfields = [];

      myfields = this.hasCustomerIndex
        ? this.formTemplate == "pk1"
          ? this.fieldsCI
          : this.formTemplate == "pk2"
          ? this.fields2CI
          : this.formTemplate == "pken2"
          ? this.fieldsen2CI
          : this.fieldsenCI
        : this.formTemplate == "pk1"
        ? this.fields
        : this.formTemplate == "pk2"
        ? this.fields2
        : this.formTemplate == "pken2"
        ? this.fieldsen2
        : this.fieldsen;

      if (!this.hasSizeStandard) {
        myfields = myfields.filter((x) => x.key != "dimensionStandard");
      }

      if (this.orderInfo.orderType == "technical") {
        myfields = myfields.filter((x) => x.key != "perPrice");
        myfields = myfields.filter((x) => x.key != "totalPrice");
      }

      return myfields;
    },
    perPriceOptions() {
      let myOptions = {
        decimal: ".",
        thousands: ",",
        precision: 0,
      };
      try {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: this.currencyOptions.filter(
            (x) => x.value == this.currency
          )[0].precision,
        };
      } catch (error) {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: 0,
        };
      }
      return myOptions;
    },
    filtered() {
      const filtered = this.orderInfo
        ? this.orderInfo.orderItems.filter((item) => {
            return Object.keys(this.filters).every((key) =>
              String(item[key])
                .toLowerCase()
                .includes(this.filters[key].toLowerCase())
            );
          })
        : null;
      return filtered;
    },
  },
  created() {
    this.getTaskInfo();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped lang="scss">
textarea {
  padding: 2px !important;
}

hr {
  border: none;
  border-top: 3px double #333;
  color: #333;
  overflow: visible;
  text-align: center;
  height: 5px;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
